import { useTheme } from "next-themes";

// Every workspace (agents, offices, teams, property hubs, builders, photographers)
// follows the app/system colour scheme. Shell and page content share this one rule
// (Calm's usePalette uses it), so night ink never lands on a paper shell and
// inputs (which follow the html .dark class) always match the page around them.
export function useShellDark() {
  const { resolvedTheme } = useTheme();
  return resolvedTheme === "dark";
}
